/**
 * This is a file containing constants for navigators located directly in the RootStack in AuthScreens file
 * The ResponsiveStackNavigator displays stack differently based on these constants
 * */
export default {
  CENTRAL_PANE_NAVIGATOR: 'CentralPaneNavigator',
  BOTTOM_TAB_NAVIGATOR: 'BottomTabNavigator',
  LEFT_MODAL_NAVIGATOR: 'LeftModalNavigator',
  RIGHT_MODAL_NAVIGATOR: 'RightModalNavigator',
  FULL_SCREEN_NAVIGATOR: 'FullScreenNavigator',
  ONBOARDING_MODAL_NAVIGATOR: 'OnboardingModalNavigator',
  SESSIONS_CALENDAR_NAVIGATOR: 'SessionsCalendarNavigator',
  DAY_OVERVIEW_NAVIGATOR: 'DayOverviewNavigator',
} as const;
